import React from 'react';
import './PrimaryHeading.styles.scss';

function PrimaryHeading ({ children }) {
    return (
        <h1 className="primary-heading">
            {children}
        </h1>
    );
}

export default PrimaryHeading;